import React, { useState, useEffect } from 'react'

// Material UI
import Checkbox from '@material-ui/core/Checkbox'
import Divider from '@material-ui/core/Divider'
import Grid from '@material-ui/core/Grid'
import List from '@material-ui/core/List'

// Icons
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'

export default function UnlimitedOptions({ options, index, addChoice }) {

    const [selectedChoices, setSelectedChoices] = useState([])

    const styles = { alignItems: "baseline" }

    const filterIncludedChoices = (selectedChoice) => {

        let filteredChoices

        filteredChoices = selectedChoices.filter(x => x.UID !== selectedChoice.UID)

        if (options.Choice_Qty >= filteredChoices.length) {

            filteredChoices = selectedChoices.filter(x => x.UID !== selectedChoice.UID)

            filteredChoices.forEach(choice => {
                let option = options.Choices.find(x => x.UID === choice.UID)
                choice.Price = option.Price
            })
        }

        return filteredChoices
    }

    const computeIncludedChoices = (selectedChoice) => {

        let choice = { ...selectedChoice }

        if (options.Choice_Qty <= selectedChoices.length)
            choice.Price += options.Extra

        return [...selectedChoices, choice]

    }

    const setCheckedItems = (choice) => {

        choice.Quantity = 1

        setSelectedChoices(
            (selectedChoices.some(x => x.UID === choice.UID)
                ? filterIncludedChoices(choice)
                : computeIncludedChoices(choice)
            )
        )
    }

    useEffect(() => {

        let choices
        let totalAmount = selectedChoices.reduce((sum, option) => sum + option.Price, 0)

        choices = {
            UID: options.UID,
            name: options.Name,
            expected: options.Choice_Qty,
            selected: selectedChoices.length,
            price: totalAmount,
            choices: selectedChoices
        }

        addChoice(index, choices)
        // eslint-disable-next-line
    }, [selectedChoices])


    if (options.length === 0) {
        return <>Loading....</>
    }

    return (
        <>
            <List>
                <h3>{options.Name}</h3>
                {options.Choices.map((choice) =>
                    <div key={choice.UID}>
                        <Grid justify="space-between" container style={styles}>
                            <Grid item>
                                {choice.Name}
                            </Grid>
                            <Grid item>
                                <>
                                    {(choice.Price === 0) ? "" : choice.Price.toFixed(2) + "$"}
                                    <Checkbox
                                        tabIndex={-1}
                                        disableRipple
                                        icon={<RadioButtonUncheckedIcon />}
                                        checkedIcon={<RadioButtonCheckedIcon />}
                                        size={"medium"}
                                        onChange={() => setCheckedItems(choice)}
                                    />
                                </>
                            </Grid>
                        </Grid>
                        <Divider />
                    </div>
                )}
            </List>
        </>
    )
}